var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "menu_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2758",
    "data-name": "Rectangle 2758",
    width: 30,
    height: 30,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2572",
    "data-name": "Path 2572",
    d: "M53.563,120H32.938a.938.938,0,0,0,0,1.875H53.563a.938.938,0,0,0,0-1.875Z",
    transform: "translate(-28.25 -105.938)",
    fill: "#0d3c61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2573",
    "data-name": "Path 2573",
    d: "M32.827,57.875H51.012a.945.945,0,0,0,0-1.875H32.827a.945.945,0,0,0,0,1.875Z",
    transform: "translate(-28.25 -49.438)",
    fill: "#0d3c61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2574",
    "data-name": "Path 2574",
    d: "M46.259,184H32.62c-.342,0-.62.42-.62.938s.278.938.62.938H46.259c.342,0,.62-.42.62-.937S46.6,184,46.259,184Z",
    transform: "translate(-28.25 -162.438)",
    fill: "#0d3c61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu_icon.482546fa073066f16b954be685f9d7a4.svg";
export { ForwardRef as ReactComponent };